/* Decorative motion is optional, silent, and idle outside the viewport. */
(() => {
  'use strict';
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  document.querySelectorAll('[data-mc-motion]').forEach(stage => {
    const video = stage.querySelector('[data-motion-video]');
    const button = stage.querySelector('[data-motion-toggle]');
    if (!video || !button) return;
    const label = button.querySelector('[data-motion-label]');
    const icon = button.querySelector('[data-motion-icon]');
    let enabled = !reduced.matches && !navigator.connection?.saveData;
    let visible = false;
    let failed = false;
    let playingRequest = false;
    function sync() {
      const active = enabled && visible && !document.hidden;
      stage.dataset.motionState = active ? 'playing' : 'paused';
      label.textContent = enabled ? 'Pausar movimiento' : 'Activar movimiento';
      icon.textContent = enabled ? 'Ⅱ' : '▶';
      button.setAttribute('aria-label', label.textContent);
      if (!active) { video.pause(); return; }
      if (failed || playingRequest || !video.paused) return;
      if (!video.getAttribute('src')) video.src = video.dataset.src;
      video.muted = true;
      playingRequest = true;
      const attempt = video.play();
      if (attempt?.then) attempt.then(() => {
        playingRequest = false;
        if (!enabled || !visible || document.hidden) video.pause();
      }).catch(() => {
        playingRequest = false;
        enabled = false;
        sync();
      }); else playingRequest = false;
    }
    button.hidden = false;
    button.addEventListener('click', () => { enabled = !enabled; sync(); });
    video.addEventListener('error', () => { failed = true; video.hidden = true; sync(); });
    document.addEventListener('visibilitychange', sync);
    const preferenceChanged = () => { enabled = !reduced.matches && !navigator.connection?.saveData; sync(); };
    reduced.addEventListener?.('change', preferenceChanged);
    navigator.connection?.addEventListener?.('change', preferenceChanged);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(entries => {
        visible = entries.some(entry => entry.isIntersecting);
        sync();
      }, { threshold: 0.1 }).observe(stage);
    } else { visible = true; }
    sync();
  });
})();
